<template>
  <v-dialog v-model="visible" width="500" max-width="350">
    <v-card dark :class="type">
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text v-if="body">
        <p class="body-1">{{ body }}</p>
      </v-card-text>
      <v-card-actions>
        <v-col class="text-right">
          <v-btn :color="getColor(type)" @click="close" elevation="0">Fechar</v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "InfoDialogComponent",
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: "Sucesso!"
    },
    body: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: "success"
    }
  },
  methods: {
    close() {
      this.visible = false;
      this.$destroy();
      removeElement(this.$el);
    },
    getColor(type){
      let color = '#37713b';
      if(type === 'error') {
        color = '#8b2526';
      }
      if(type === 'warning') {
        color = '#bc8413';
      }
      return color;
    }
  },
  beforeMount() {
    document.querySelector("#app").appendChild(this.$el);
  }
};

function removeElement(el) {
  if (typeof el.remove !== "undefined") {
    el.remove();
  } else {
    el.parentNode.removeChild(el);
  }
}
</script>

<style>
.success {
  background-color: #37713b;
}

.error {
  background-color: #8b2526;
}

.warning {
  background-color: #bc8413;
}
</style>
